import { Col, Row, Badge } from 'react-bootstrap';
import { CheckCircleFill, ChevronRight, Copy } from 'react-bootstrap-icons';
import Divider from '../../../components/Divider/Divider';
import CareMapprButton from '../../../components/Button/CareMapprButton';
import { MedicationProfileStates, MedicationProfileSteps } from '../types';
import CareMapprIconButton from '../../../components/Button/CareMapprIconButton';
import TrashIcon from '../../../../assets/img/button-icons/trash-red.svg';

import './style.css';
import { MedProfile } from '../hook/types';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useGlobalLoading } from '../../../../context';
import { useEffect } from 'react';

//@ts-expect-error
const RowInfo = ({ name, detail, date }) => {
  return (
    <Col sm={6}>
      <Row className="mb-1 row-action-font medication-profile-font-gray">
        {name}
      </Row>
      <Row className="mb-1 row-action-font-sm medication-profile-font-gray">
        {detail}
      </Row>
      <Row className="row-action-font-sm medication-profile-font-gray">
        {date}
      </Row>
    </Col>
  );
};

const RowActions = ({
  data,
  onChangeTab,
  onDelete,
  canEdit,
  isDeleting: isApiDeleting,
  onDuplicate,
  onOpenDeleteConfirm,
}: {
  data: MedProfile;
  onChangeTab: unknown;
  onDelete: (id: string) => void | Promise<void>;
  canEdit: boolean;
  isDeleting: string;
  onDuplicate: (id: string) => void;
  onOpenDeleteConfirm: (id: string) => void;
}) => {
  const state = data.profileStatus;

  // Check if any medication in the profile is health provider verified
  const isHealthProviderVerified = data.healthProviderVerified;

  const badgeType = () => {
    switch (state) {
      case MedicationProfileStates.FINALISED:
        return 'finalised';
      case MedicationProfileStates.ENTERED_IN_ERROR:
        return 'entered in error';
      case MedicationProfileStates.IN_PROGRESS:
        return 'in progress';
      case MedicationProfileStates.CONSUMER_CREATED:
        return 'consumer created';
      default:
        return '';
    }
  };

  const badgeTypeClass = () => {
    switch (state) {
      case MedicationProfileStates.FINALISED:
        return 'finalised';
      case MedicationProfileStates.ENTERED_IN_ERROR:
        return 'entered-in-error';
      case MedicationProfileStates.IN_PROGRESS:
        return 'in-progress';
      case MedicationProfileStates.CONSUMER_CREATED:
        return 'consumer-created';
      default:
        return '';
    }
  };
  const handleDelete = () => {
    onOpenDeleteConfirm(data.id);
  };
  return (
    <Col
      sm={6}
      className="flex-wrap justify-content-end d-flex gap-1 align-items-center"
    >
      {badgeType && (
        <Badge pill className={`medication-badge ${badgeTypeClass()}`}>
          <CheckCircleFill color="white" />
          <span className="badge-text">{badgeType()}</span>
        </Badge>
      )}
      {isHealthProviderVerified && (
        <Badge pill className="medication-badge health-provider-verified">
          <CheckCircleFill color="white" />
          <span className="badge-text">Health provider verified</span>
        </Badge>
      )}

      {canEdit && (
        <CareMapprButton
          endIcon={<Copy size={14} />}
          label="Duplicate"
          labelClassName="medication-duplicate-button"
          variant="transparent"
          hoverWithColor
          onClick={() => onDuplicate(data.id)}
        />
      )}
      {canEdit && data.profileStatus !== 'entered in error' && (
        <CareMapprIconButton
          icon={<img src={TrashIcon} alt="trash icon" />}
          onClick={handleDelete}
          disabled={isApiDeleting === data.id}
        />
      )}

      <CareMapprButton
        endIcon={<ChevronRight size={14} />}
        label="View"
        onClick={() =>
          // @ts-expect-error
          onChangeTab(MedicationProfileSteps.MEDICATION_DETAIL, data.id)
        }
        labelClassName="medication-view-button"
        variant="transparent"
      />
      {/* Confirmation modal moved to parent to ensure a single instance */}
    </Col>
  );
};

const MedicationProfileRow = ({
  data,
  onDelete,
  onView,
  onDuplicate,
  onChangeTab,
  canEdit,
  isDeleting,
  onOpenDeleteConfirm,
}: {
  data: MedProfile;
  onDelete: (id: string) => void;
  onView: unknown;
  onDuplicate: (id: string) => void;
  onChangeTab: unknown;
  canEdit: boolean;
  isDeleting: string;
  onOpenDeleteConfirm: (id: string) => void;
}) => {
  const { patientProfile } = useSelector((state: any) => state.patientProfile);
  const updatedDate = moment(data.updatedAt).format('DD MMM YY');
  const { startLoading, stopLoading } = useGlobalLoading();

  useEffect(() => {
    if (!isDeleting) {
      stopLoading();
      return;
    }
    if (isDeleting === data.id) {
      startLoading('Marking as entered in error');
    }
  }, [isDeleting]);
  // TODO: will enable in the later stage
  // const relatedPathology =
  //   data?.medSections?.[0]?.medications?.[0]?.relatedPathology || '-';
  return (
    <>
      <Row className="align-items-start px-4">
        <RowInfo
          name={`Medication profile - ${patientProfile.first_name} ${patientProfile.last_name}`}
          // detail={`Related pathology: ${relatedPathology}`}
          // TODO: will enable in the later stage
          detail=""
          date={updatedDate}
        />
        <RowActions
          data={data}
          onChangeTab={onChangeTab}
          onDelete={onDelete}
          canEdit={canEdit}
          isDeleting={isDeleting}
          onDuplicate={onDuplicate}
          onOpenDeleteConfirm={onOpenDeleteConfirm}
        />
      </Row>
      <Divider />
    </>
  );
};

export default MedicationProfileRow;
